"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileFieldValueGetter = void 0;
const safe_field_value_1 = require("../safe-field-value");
const file_1 = require("../type-checking/file");
const utils_1 = require("./utils");
class FileFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, file_1.isFileFieldValue)(fieldValue);
        };
        this.getEmptyValue = () => [];
        this.isOptimizedFieldValue = (fieldValue) => {
            return (0, file_1.isOptimizedFileFieldValue)(fieldValue);
        };
        this.getValueFromOptimized = (fieldValue) => {
            return fieldValue
                .filter(({ handle }) => handle)
                .map((file) => {
                var _a, _b, _c, _d, _e;
                const { handle, name, mimetype, size, container, key, ...other } = file;
                return {
                    ...other,
                    handle: handle !== null && handle !== void 0 ? handle : "",
                    metadata: {
                        mimetype: mimetype !== null && mimetype !== void 0 ? mimetype : "",
                        filename: name !== null && name !== void 0 ? name : "",
                        size: size !== null && size !== void 0 ? size : 0,
                        container: container !== null && container !== void 0 ? container : "",
                        key: key !== null && key !== void 0 ? key : "",
                    },
                    file_type: (0, utils_1.getFileType)((_a = file === null || file === void 0 ? void 0 : file.mimetype) !== null && _a !== void 0 ? _a : ""),
                    icon: (0, utils_1.getIconByMimeType)((_b = file === null || file === void 0 ? void 0 : file.mimetype) !== null && _b !== void 0 ? _b : ""),
                    video_conversion_status: (_c = other.video_conversion_status) !== null && _c !== void 0 ? _c : "",
                    video_thumbnail_handle: (_d = other.video_thumbnail_handle) !== null && _d !== void 0 ? _d : "",
                    converted_video_handle: (_e = other.converted_video_handle) !== null && _e !== void 0 ? _e : "",
                };
            });
        };
    }
}
exports.FileFieldValueGetter = FileFieldValueGetter;
